import alert from '@/plugins/alert'
import { Bill, Lead } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    bills: {},
    count: 0
  },
  actions: {
    async fetchBills({ commit }, options) {
      commit(
        'setBills',
        await Bill.fetch({ ...options, _limit: -1, _sort: 'createdAt:desc' })
      )
    },
    async countBills({ commit }, options) {
      commit('setCount', await Bill.count(options))
    },
    async fetchBill({ commit }, billId) {
      commit('setBill', await Bill.fetchOne(billId))
    },
    async fetchLead({ commit }, id) {
      return Lead.fetchOne(id)
    },
    async updateLead({ commit, state }, { id, ...lead }) {
      return Lead.update(id, lead)
    },
    // api is create or update. If record exist then create.
    async createBill({ commit }, { data, options }) {
      commit('setBill', await Bill.create(data, options))
      alert.success('Cập nhật thành công!')
    },
    async removeBill({ commit }, id) {
      await Bill.remove(id)
      commit('removeBill', id)
      alert.success('Xóa thành công!')
    },
    setBill({ commit, state }, bill) {
      commit('setBill', bill)
    },
    async removeBills({ dispatch }, items) {
      for (let item of items) {
        await dispatch('removeBill', item.id)
      }
    },
    async updateBill({ commit, state }, { id, ...bill }) {
      try {
        commit('setBill', await Bill.update(id, bill))
        alert.success('Cập nhật thành công!')
      } catch (e) {
        alert.error(e)
      }
    },
    async updateBills({ dispatch }, items) {
      await Promise.all(
        items.map(item => dispatch('createBill', { data: item }))
      )
    }
  },
  mutations: {
    setBills(state, bills) {
      state.bills = bills.reduce(
        (accumulator, currentValue) => ({
          ...accumulator,
          [currentValue.id]: currentValue
        }),
        {}
      )
    },
    setBill(state, bill) {
      state.bills = {
        ...state.bills,
        [bill.id]: bill
      }
    },
    removeBill(state, billId) {
      delete state.bills[billId]
      state.bills = { ...state.bills }
    },
    setCount(state, count) {
      state.count = count
    }
  },
  getters: {
    bills: state => {
      return Object.values(state.bills)
    },
    bill: state => id => {
      return state.bills[id]
    },
    count: state => {
      return state.count
    }
  }
}
